const actions = {
  SET_CATEGORY: "SET_CATEGORY",
  SET_WHERE_FILTERS: "SET_WHERE_FILTERS",
  SET_SEARCH_ARG_QUERY: "SET_SEARCH_ARG_QUERY",
  SET_PATH_LEVEL: "SET_PATH_LEVEL",
  SET_PAGE: "SET_PAGE",
  SET_LAST_FIND_QUERY_VARS: "SET_LAST_FIND_QUERY_VARS",
  TOGGLE_USER_SIDEBAR: "TOGGLE_USER_SIDEBAR",
  TOGGLE_SERVICES_POPUP: "TOGGLE_SERVICES_POPUP",
  TOGGLE_SEARCHBAR: "TOGGLE_SEARCHBAR",
  SET_POLYGON: "SET_POLYGON",
  setCategory: (payload) => ({
    type: actions.SET_CATEGORY,
    payload,
  }),
  setWhereFilters: (payload) => ({
    type: actions.SET_WHERE_FILTERS,
    payload,
  }),
  setSearchArgQuery: (payload) => ({
    type: actions.SET_SEARCH_ARG_QUERY,
    payload,
  }),
  setPathLevel: (payload) => ({
    type: actions.SET_PATH_LEVEL,
    payload,
  }),
  setPage: (payload) => ({
    type: actions.SET_PAGE,
    payload,
  }),
  setLastFindQueryVariables: (payload) => ({
    type: actions.SET_LAST_FIND_QUERY_VARS,
    payload,
  }),
  toggleUserSidebar: () => ({
    type: actions.TOGGLE_USER_SIDEBAR,
  }),
  toggleServicesPopup: () => ({
    type: actions.TOGGLE_SERVICES_POPUP,
  }),
  toggleSearchbar: (payload) => ({
    type: actions.TOGGLE_SEARCHBAR,
    payload,
  }),
  setPolygon: (payload) => ({
    type: actions.SET_POLYGON,
    payload,
  }),
};

export default actions;
